import { message } from 'antd';
import { InputOTP } from 'antd-input-otp';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import Ava from '../../components/Common/Ava/Ava';
// import Button from '../../components/Common/Button/Button';
import ControlledInput from '../../components/Common/ControlledInput/ControlledInput';
import IosModal from '../../components/Common/IosModal/IosModal';
import Search from '../../components/Common/Search/Search';
import ShortProfile from '../../components/Common/ShortProfile/ShortProfile';
import Modal from '../../components/Modal/Modal';
import Title from '../../components/Title/Title';
import DeactiveTwoFA from '../../components/TwoFA/DeactiveTwoFA';
import TwoFA from '../../components/TwoFA/TwoFA';
import { TRootState } from '../../store/store';
import { resetLogin, resetProfile, resetTwoFa, resetUser } from '../../store/user/user.slice';
import { transport } from '../../utils/constants';
import {
    copyToClipboard,
    getColor,
    getDate,
    getName,
    getToken,
    isRpcError,
    Notification,
    setAvas,
    type,
} from '../../utils/helper';
import { getIdsByBitMask } from '../Team/Team';
import './Profile.scss';
import { AccountClient } from '../../generated/mlmbox/client/account/account.client';
import { GoogleAuthenticatorClient } from '../../generated/mlmbox/client/google_authenticator/google_authenticator.client';
import { Status_GoogleAuthenticatorVerifiedCode } from '../../generated/mlmbox/types/status';
import { Account_Info } from '../../generated/mlmbox/types/account';
import { NetworkClient } from '../../generated/mlmbox/client/network/network.client';
import Web3 from '../../components/Web3/Web3';
import Button from '../../components/Button/Button';
import { detachIcon } from '../../assets';

function AboutUser() {
    const user = useSelector((state: TRootState) => state.user.value);
    const [value, setValue] = useState('');
    const [valueName, setValueName] = useState('');
    const [addLogin, setAddLogin] = useState(false);
    const [addName, setAddName] = useState(false);
    const [loginValue, setLoginValue] = useState('');
    const account = new AccountClient(transport);

    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        setValue(user.info.profile.firstName + ' ' + user.info.profile.lastName);
        setLoginValue(user.info.account.login);
    }, [user]);

    const errorLogin: { [key: string]: string } = {
        LOGIN_UNKNOWN: t('errors.login_unknown'),
        LOGIN_FORMAT_LEN_SHORT: t('errors.login_short'),
        LOGIN_FORMAT_LEN_LONG: t('errors.login_long'),
        LOGIN_FORMAT_UNSUPPORTED: t('errors.login_format'),
        LOGIN_FORMAT_IDENTIFICATION: t('errors.login_bad'),
        LOGIN_BUSY: t('errors.login_busy'),
    };

    function setName(value: string) {
        account
            .setProfile(
                { firstName: value.trim().split(' ')[0] || '', lastName: value.trim().split(' ')[1] || '' },
                { meta: { authorization: getToken() } }
            )
            .then(({ status, response }) => {
                if (status.code === 'OK') {
                    // if (typeof response.telegram?.id === 'bigint') {
                    //     response.telegram.id = Number(response.telegram.id);
                    // }

                    dispatch(
                        resetProfile({
                            state: user,
                            profile: response,
                        })
                    );
                    message.success(t('profile.user.msg.success'));
                    setValue(response.firstName + ' ' + response.lastName);
                }
            })
            .catch((e) => {
                console.log(e);
                message.error(t('profile.user.msg.error'));
                setValue(user.info.profile.firstName + ' ' + user.info.profile.lastName);
            });
        // setEdit(false);
    }

    useEffect(() => {
        setValueName(`${user.info.profile.firstName} ${user.info.profile.lastName}`);
    }, [user.info]);

    function saveLogin(value: string) {
        if (!value.length) return;

        account
            .setLogin({ login: value }, { meta: { authorization: getToken() } })
            .then(({ response, status }) => {
                if (status.code === 'OK') {
                    dispatch(resetLogin({ login: response.login }));
                    Notification(type.success);

                    message.success(t('login.msgs.success'));
                }
            })
            .catch((error) => {
                if (isRpcError(error)) {
                    Notification(type.error);
                    setAddLogin(false);
                    message.error(errorLogin[error.message]);
                }
            });
    }

    return (
        <div className="about">
            <div className="about-user block">
                <div className="img">
                    <Ava
                        width="80px"
                        height="80px"
                        collectionId={user.info.profile.ava.collectionId}
                        entityId={user.info.profile.ava.entityId}
                    />
                </div>
                <h1 onClick={() => setAddName(true)}>
                    {valueName}{' '}
                    <svg
                        className="name"
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none">
                        <g opacity="0.8">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.90308 6.90113C5.33815 6.90113 4.78591 6.73361 4.31619 6.41975C3.84647 6.1059 3.48037 5.6598 3.26418 5.13787C3.04799 4.61595 2.99143 4.04164 3.10164 3.48756C3.21185 2.93349 3.48389 2.42454 3.88335 2.02508C4.28282 1.62561 4.79177 1.35357 5.34584 1.24336C5.89991 1.13315 6.47423 1.18971 6.99615 1.4059C7.51808 1.62209 7.96417 1.98819 8.27803 2.45791C8.59189 2.92764 8.75941 3.47988 8.75941 4.04481C8.7574 4.80173 8.45582 5.52708 7.92059 6.06231C7.38536 6.59754 6.66001 6.89912 5.90308 6.90113ZM5.90308 2.33101C5.56413 2.33101 5.23278 2.43152 4.95095 2.61984C4.66912 2.80815 4.44945 3.07581 4.31974 3.38896C4.19003 3.70212 4.15609 4.04671 4.22222 4.37915C4.28834 4.71159 4.45157 5.01696 4.69124 5.25664C4.93092 5.49632 5.23629 5.65954 5.56874 5.72567C5.90118 5.7918 6.24577 5.75786 6.55892 5.62815C6.87208 5.49843 7.13974 5.27877 7.32805 4.99694C7.51637 4.71511 7.61688 4.38376 7.61688 4.04481C7.61688 3.59028 7.43632 3.15437 7.11492 2.83297C6.79352 2.51157 6.35761 2.33101 5.90308 2.33101ZM0.571266 12.2329C0.419756 12.2329 0.274453 12.1727 0.16732 12.0655C0.0601868 11.9584 0 11.8131 0 11.6616C0 8.04358 4.13596 8.04358 5.90308 8.04358C6.45149 8.04358 6.93897 8.04358 7.38075 8.0969C7.53102 8.10859 7.67058 8.1792 7.76903 8.29333C7.86747 8.40747 7.91682 8.55589 7.90631 8.70625C7.89273 8.85717 7.8205 8.99675 7.70515 9.09501C7.5898 9.19328 7.44051 9.24239 7.28935 9.23181C7.09554 9.23181 6.89159 9.22167 6.6759 9.21093L6.67586 9.21093H6.67585C6.4338 9.19889 6.17696 9.18611 5.90308 9.18611C1.95754 9.18611 1.14253 10.1763 1.14253 11.6616C1.14356 11.7369 1.12948 11.8116 1.10113 11.8814C1.07279 11.9512 1.03075 12.0146 0.977494 12.0678C0.924242 12.1211 0.860858 12.1631 0.791086 12.1915C0.721314 12.2198 0.646569 12.2339 0.571266 12.2329ZM7.10653 12.6442C7.21356 12.7514 7.35876 12.8117 7.51022 12.8118L7.56354 12.7889L9.04121 12.6518C9.17417 12.6393 9.29834 12.5799 9.39159 12.4843L13.5961 8.27975C13.727 8.14593 13.83 7.98751 13.8993 7.81363C13.9686 7.63975 14.0028 7.45386 13.9998 7.26671C14.003 7.06367 13.9655 6.86204 13.8897 6.67368C13.8138 6.48532 13.701 6.31403 13.558 6.16988C13.2679 5.90114 12.8871 5.75183 12.4917 5.75183C12.0962 5.75183 11.7154 5.90114 11.4253 6.16988L7.22078 10.3744C7.12689 10.4711 7.07024 10.5979 7.06082 10.7324L6.93895 12.1948C6.93102 12.2775 6.94198 12.361 6.97101 12.4388C7.00004 12.5167 7.04638 12.5869 7.10653 12.6442ZM8.1348 11.6083L8.1805 11.0294L12.2327 7.00012C12.3076 6.94447 12.3984 6.91442 12.4917 6.91442C12.5849 6.91442 12.6758 6.94447 12.7506 7.00012C12.8192 7.08099 12.857 7.18352 12.8573 7.28956C12.8611 7.3643 12.8367 7.43774 12.7887 7.49521L8.72892 11.555L8.1348 11.6083Z"
                                fill="white"
                            />
                        </g>
                    </svg>
                </h1>
                {user?.info?.account?.login && (
                    <p onClick={() => setAddLogin(true)}>
                        TTM Login: <span>@{user.info.account.login}</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none">
                            <g opacity="0.8">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M5.90308 6.90113C5.33815 6.90113 4.78591 6.73361 4.31619 6.41975C3.84647 6.1059 3.48037 5.6598 3.26418 5.13787C3.04799 4.61595 2.99143 4.04164 3.10164 3.48756C3.21185 2.93349 3.48389 2.42454 3.88335 2.02508C4.28282 1.62561 4.79177 1.35357 5.34584 1.24336C5.89991 1.13315 6.47423 1.18971 6.99615 1.4059C7.51808 1.62209 7.96417 1.98819 8.27803 2.45791C8.59189 2.92764 8.75941 3.47988 8.75941 4.04481C8.7574 4.80173 8.45582 5.52708 7.92059 6.06231C7.38536 6.59754 6.66001 6.89912 5.90308 6.90113ZM5.90308 2.33101C5.56413 2.33101 5.23278 2.43152 4.95095 2.61984C4.66912 2.80815 4.44945 3.07581 4.31974 3.38896C4.19003 3.70212 4.15609 4.04671 4.22222 4.37915C4.28834 4.71159 4.45157 5.01696 4.69124 5.25664C4.93092 5.49632 5.23629 5.65954 5.56874 5.72567C5.90118 5.7918 6.24577 5.75786 6.55892 5.62815C6.87208 5.49843 7.13974 5.27877 7.32805 4.99694C7.51637 4.71511 7.61688 4.38376 7.61688 4.04481C7.61688 3.59028 7.43632 3.15437 7.11492 2.83297C6.79352 2.51157 6.35761 2.33101 5.90308 2.33101ZM0.571266 12.2329C0.419756 12.2329 0.274453 12.1727 0.16732 12.0655C0.0601868 11.9584 0 11.8131 0 11.6616C0 8.04358 4.13596 8.04358 5.90308 8.04358C6.45149 8.04358 6.93897 8.04358 7.38075 8.0969C7.53102 8.10859 7.67058 8.1792 7.76903 8.29333C7.86747 8.40747 7.91682 8.55589 7.90631 8.70625C7.89273 8.85717 7.8205 8.99675 7.70515 9.09501C7.5898 9.19328 7.44051 9.24239 7.28935 9.23181C7.09554 9.23181 6.89159 9.22167 6.6759 9.21093L6.67586 9.21093H6.67585C6.4338 9.19889 6.17696 9.18611 5.90308 9.18611C1.95754 9.18611 1.14253 10.1763 1.14253 11.6616C1.14356 11.7369 1.12948 11.8116 1.10113 11.8814C1.07279 11.9512 1.03075 12.0146 0.977494 12.0678C0.924242 12.1211 0.860858 12.1631 0.791086 12.1915C0.721314 12.2198 0.646569 12.2339 0.571266 12.2329ZM7.10653 12.6442C7.21356 12.7514 7.35876 12.8117 7.51022 12.8118L7.56354 12.7889L9.04121 12.6518C9.17417 12.6393 9.29834 12.5799 9.39159 12.4843L13.5961 8.27975C13.727 8.14593 13.83 7.98751 13.8993 7.81363C13.9686 7.63975 14.0028 7.45386 13.9998 7.26671C14.003 7.06367 13.9655 6.86204 13.8897 6.67368C13.8138 6.48532 13.701 6.31403 13.558 6.16988C13.2679 5.90114 12.8871 5.75183 12.4917 5.75183C12.0962 5.75183 11.7154 5.90114 11.4253 6.16988L7.22078 10.3744C7.12689 10.4711 7.07024 10.5979 7.06082 10.7324L6.93895 12.1948C6.93102 12.2775 6.94198 12.361 6.97101 12.4388C7.00004 12.5167 7.04638 12.5869 7.10653 12.6442ZM8.1348 11.6083L8.1805 11.0294L12.2327 7.00012C12.3076 6.94447 12.3984 6.91442 12.4917 6.91442C12.5849 6.91442 12.6758 6.94447 12.7506 7.00012C12.8192 7.08099 12.857 7.18352 12.8573 7.28956C12.8611 7.3643 12.8367 7.43774 12.7887 7.49521L8.72892 11.555L8.1348 11.6083Z"
                                    fill="white"
                                />
                            </g>
                        </svg>
                    </p>
                )}

                {!user.info.account.login && (
                    <Button
                        height="50px"
                        title={t('btns.add_login')}
                        onClick={() => setAddLogin(true)}
                    />
                )}
            </div>
            <div className="about-meta">
                <p>
                    {t('reg')} {getDate(user.info.registrationAt)}
                </p>
                <p
                    onClick={async () => {
                        await copyToClipboard(String(user.info.account.id));
                        message.success(t('copy'));
                    }}>
                    Account ID: <span>{user.info.account.id}</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none">
                        <g opacity="0.8">
                            <path
                                d="M12.4063 4.12821L8.43604 0.157949C8.33515 0.0569387 8.19828 0.000125678 8.05552 0H6.28219C5.75856 0 5.25637 0.208012 4.88611 0.578276C4.51584 0.948541 4.30783 1.45073 4.30783 1.97436V2.87179H3.41039C2.88676 2.87179 2.38458 3.07981 2.01431 3.45007C1.64405 3.82034 1.43604 4.32252 1.43604 4.84615V12.0256C1.43604 12.5493 1.64405 13.0515 2.01431 13.4217C2.38458 13.792 2.88676 14 3.41039 14H8.43604C8.95967 14 9.46185 13.792 9.83212 13.4217C10.2024 13.0515 10.4104 12.5493 10.4104 12.0256V11.1282H10.5899C11.1135 11.1282 11.6157 10.9202 11.986 10.5499C12.3562 10.1797 12.5642 9.67748 12.5642 9.15385V4.48718C12.5586 4.35192 12.5022 4.22375 12.4063 4.12821ZM8.61552 1.83795L10.7263 3.94872H8.61552V1.83795ZM9.33347 12.0256C9.33347 12.2637 9.23892 12.4919 9.07062 12.6602C8.90232 12.8285 8.67405 12.9231 8.43604 12.9231H3.41039C3.17238 12.9231 2.94411 12.8285 2.77581 12.6602C2.60751 12.4919 2.51296 12.2637 2.51296 12.0256V4.84615C2.51296 4.60814 2.60751 4.37987 2.77581 4.21157C2.94411 4.04327 3.17238 3.94872 3.41039 3.94872H4.30783V9.15385C4.30783 9.67748 4.51584 10.1797 4.88611 10.5499C5.25637 10.9202 5.75856 11.1282 6.28219 11.1282H9.33347V12.0256ZM10.5899 10.0513H6.28219C6.04417 10.0513 5.81591 9.95673 5.64761 9.78843C5.4793 9.62013 5.38475 9.39186 5.38475 9.15385V1.97436C5.38475 1.73634 5.4793 1.50808 5.64761 1.33978C5.81591 1.17147 6.04417 1.07692 6.28219 1.07692H7.5386V4.48718C7.54046 4.62941 7.59779 4.76529 7.69837 4.86587C7.79895 4.96645 7.93483 5.02378 8.07706 5.02564H11.4873V9.15385C11.4873 9.39186 11.3928 9.62013 11.2245 9.78843C11.0562 9.95673 10.8279 10.0513 10.5899 10.0513Z"
                                fill="#89B1FF"
                            />
                        </g>
                    </svg>
                </p>
            </div>

            {addLogin && (
                <ControlledInput
                    title={t('modals.ios.header.titles.login')}
                    close={() => setAddLogin(false)}
                    typeInput="text"
                    setValue={setLoginValue}
                    value={loginValue}
                    placeholder="your_login"
                    fetch={saveLogin}>
                    <ul className="login">
                        <li>{t('login.settings.help_list.item_1')}</li>
                        <li>{t('login.settings.help_list.item_2')}</li>
                        <li>{t('login.settings.help_list.item_3')}</li>
                    </ul>
                </ControlledInput>
            )}
            {addName && (
                <ControlledInput
                    title={t('modals.ios.header.titles.name')}
                    close={() => setAddName(false)}
                    typeInput="text"
                    setValue={setValue}
                    value={value}
                    placeholder={t('placeholders.name')}
                    fetch={setName}></ControlledInput>
            )}
        </div>
    );
}

function TwoFACHeck() {
    const [open, setOpen] = useState(false);
    const [openCode, setOpenCode] = useState(false);
    const googleAuthenticator = useSelector((state: TRootState) => state.user.value.googleAuthenticator);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const twoFAClient = new GoogleAuthenticatorClient(transport);

    const [fetching, setFEtching] = useState(false);

    async function codeComplete(code: string[]) {
        setFEtching(true);
        message.destroy();
        if (!code || code.length < 6) return;

        const { response, status } = await twoFAClient.activate(
            { verifiedCode: code.join('') },
            { meta: { authorization: getToken() } }
        );

        if (status.code === 'OK') {
            switch (response.status) {
                case Status_GoogleAuthenticatorVerifiedCode.APPROVED:
                    setOpenCode(false);
                    setFEtching(false);
                    dispatch(resetTwoFa(response.result));
                    message.success(t('twoFA.success'));

                    return;
                case Status_GoogleAuthenticatorVerifiedCode.UNKNOWN:
                    message.error(t('errors.unknown'));
                    setOpenCode(false);
                    setFEtching(false);
                    return;
                case Status_GoogleAuthenticatorVerifiedCode.REJECTED:
                    message.error(t('errors.err_twoFA'));
                    setOpenCode(false);
                    setFEtching(false);
                    return;
                case Status_GoogleAuthenticatorVerifiedCode.WRONG_CODE:
                    message.error(t('errors.wrong_code'));
                    setFEtching(false);
                    return;
            }
        }
    }

    return (
        <>
            <div className="fa block">
                <div className="text">
                    <h2>{t('twoFA.title')}</h2>
                    <p>{googleAuthenticator.status === 1 ? t('twoFA.on_text') : t('twoFA.off_text')}</p>
                </div>{' '}
                {googleAuthenticator.status === 1 ? (
                    <Button
                        height="50px"
                        onClick={() => setOpen(true)}
                        title={t('twoFA.btns.off')}
                        disabled
                        icon={detachIcon}
                    />
                ) : (
                    <Button
                        height="50px"
                        onClick={() => setOpen(true)}
                        title={t('twoFA.btns.on')}
                    />
                )}
            </div>
            {open &&
                (googleAuthenticator.status === 1 ? (
                    <DeactiveTwoFA closeBtn={() => setOpen(false)} />
                ) : (
                    <TwoFA
                        btnTo={() => {
                            setOpenCode(true);
                        }}
                        closeBtn={() => setOpen(false)}
                    />
                ))}
            {openCode && (
                <IosModal
                    cancel={() => {
                        setOpenCode(false);
                    }}
                    cancelBtnTitle={t('modals.ios.header.btns.cancel')}
                    title={t('modals.ios.header.titles.code')}>
                    <InputOTP
                        inputType="numeric"
                        type="tel"
                        inputStyle={{
                            opacity: fetching ? 0.5 : 1,
                            userSelect: 'none',
                            background: 'var(--ln-bg)',
                            border: '1px solid #5E88C7',
                            color: '#8590AC',
                            fontSize: '20px',
                            fontFamily: 'Unbounded',
                        }}
                        autoSubmit={codeComplete}
                        isPreserveFocus={true}
                    />
                </IosModal>
            )}
        </>
    );
}

const Partner: FC<{
    setAddRef: Function;
}> = ({ setAddRef }) => {
    const user = useSelector((state: TRootState) => state.user.value);
    const [sponsor, setSponsor] = useState<Account_Info | null>();
    const [open, setOpen] = useState(false);
    const [fetching, setFEtching] = useState(true);
    const { t } = useTranslation();
    const accClient = new NetworkClient(transport);

    useEffect(() => {
        setFEtching(true);
        if (!user.info.account.id) return;
        if (user.info.account.id) {
            if (!user?.info?.referral?.id) setFEtching(false);
        }
        if (!user?.info?.referral?.id) return;

        accClient
            .memberGet(
                { uniqueField: { accountId: user?.info?.referral?.id, oneofKind: 'accountId' } },
                { meta: { authorization: getToken() } }
            )
            .then(async ({ status, response }) => {
                setFEtching(false);

                if (status.code === 'OK') {
                    const info = response;
                    if (info) {
                        await setAvas([info]);
                    }
                    setSponsor(response);
                }
            });
    }, [user.info.referral]);

    return (
        <>
            <div className="partner block">
                {fetching && (
                    <div className="loading-sponsor">
                        <div className="spinner small"></div>
                    </div>
                )}
                {!user?.info?.referral?.id ? (
                    <div className="partner__not">
                        <p>{t('ref.not_ref_title')}</p>
                        <Button
                            height="50px"
                            title={t('ref.add_btn')}
                            onClick={() => setAddRef(true)}
                        />
                    </div>
                ) : (
                    !fetching && (
                        <div className="spansor">
                            <div
                                className="row"
                                onClick={() => setOpen(true)}>
                                <Ava
                                    width="40px"
                                    height="40px"
                                    collectionId={sponsor?.profile?.ava?.collectionId}
                                    entityId={sponsor?.profile?.ava?.entityId}
                                    borderColor={getColor(sponsor?.relationship)}
                                />
                                <h1>
                                    {sponsor && getName(sponsor)}
                                    <p>
                                        {sponsor?.account?.login && (
                                            <>
                                                @{sponsor.account?.login}
                                                <svg
                                                    style={{ marginInline: '8px' }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="2"
                                                    height="12"
                                                    viewBox="0 0 2 12"
                                                    fill="none">
                                                    <path
                                                        d="M1 0V12"
                                                        stroke="#506690"
                                                    />
                                                </svg>
                                            </>
                                        )}
                                        {sponsor && getIdsByBitMask(sponsor.treeIdsBitMask, sponsor.channels)}
                                    </p>
                                </h1>
                            </div>
                            {user.referralChangeAccess && (
                                <div className="re-ref">
                                    <svg
                                        onClick={() => setAddRef(true)}
                                        className="re-ref--icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none">
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M15.8657 0.258426C16.0284 0.0957355 16.2482 0.0030077 16.4783 0C16.7093 0 16.9308 0.0917623 17.0941 0.2551C17.2575 0.418439 17.3492 0.639973 17.3492 0.870968V5.80645C17.3508 5.92126 17.3293 6.03522 17.2861 6.1416C17.2429 6.24797 17.1788 6.34461 17.0976 6.4258C17.0164 6.50699 16.9198 6.57109 16.8134 6.6143C16.707 6.65752 16.5931 6.67898 16.4783 6.67742H11.5544C11.3234 6.67742 11.1019 6.58566 10.9385 6.42232C10.7752 6.25898 10.6834 6.03745 10.6834 5.80645C10.6834 5.57546 10.7752 5.35392 10.9385 5.19058C11.1019 5.02725 11.3234 4.93548 11.5544 4.93548H14.3531L13.3776 3.96C12.124 2.71119 10.4265 2.01002 8.65699 2.01002C6.88746 2.01002 5.19003 2.71119 3.93635 3.96C3.21456 4.6763 2.6698 5.55109 2.34538 6.51484C2.28562 6.68642 2.17436 6.83538 2.0268 6.94138C1.87923 7.04738 1.70254 7.10525 1.52086 7.1071C1.42481 7.12379 1.32659 7.12379 1.23054 7.1071C1.1154 7.07135 1.00908 7.01178 0.918468 6.93226C0.827859 6.85274 0.754997 6.75504 0.704616 6.64551C0.654235 6.53599 0.627461 6.41709 0.626037 6.29654C0.624612 6.17599 0.648567 6.05649 0.696346 5.94581C1.15517 4.58801 1.95348 3.37004 3.01546 2.40757C4.07743 1.4451 5.36781 0.770076 6.76406 0.446611C8.16031 0.123147 9.61607 0.161978 10.9931 0.559416C12.3701 0.956853 13.6227 1.6997 14.6318 2.71742L15.6073 3.6929V0.870968C15.6103 0.640908 15.703 0.421117 15.8657 0.258426ZM16.4171 10.8903C16.5372 10.8864 16.6568 10.907 16.7686 10.951C16.8788 10.9851 16.981 11.041 17.0691 11.1155C17.1572 11.1899 17.2294 11.2814 17.2814 11.3843C17.3334 11.4873 17.3642 11.5996 17.3718 11.7147C17.3795 11.8298 17.3639 11.9453 17.326 12.0542C16.8672 13.412 16.0689 14.63 15.0069 15.5924C13.9449 16.5549 12.6546 17.2299 11.2583 17.5534C9.86206 17.8769 8.4063 17.838 7.02928 17.4406C5.65226 17.0432 4.3997 16.3003 3.39054 15.2826L2.41506 14.3071V17.129C2.41506 17.36 2.32329 17.5816 2.15996 17.7449C1.99662 17.9082 1.77508 18 1.54409 18C1.31309 18 1.09156 17.9082 0.928221 17.7449C0.764883 17.5816 0.673121 17.36 0.673121 17.129V12.2052C0.671559 12.0904 0.69302 11.9764 0.736237 11.87C0.779454 11.7636 0.84355 11.667 0.92474 11.5858C1.00593 11.5046 1.10257 11.4405 1.20894 11.3973C1.31532 11.3541 1.42928 11.3326 1.54409 11.3342H6.46796C6.69896 11.3342 6.92049 11.426 7.08383 11.5893C7.24717 11.7526 7.33893 11.9742 7.33893 12.2052C7.33893 12.4362 7.24717 12.6577 7.08383 12.821C6.92049 12.9844 6.69896 13.0761 6.46796 13.0761H3.59957L4.57506 14.0516C5.82874 15.3004 7.52617 16.0016 9.2957 16.0016C11.0652 16.0016 12.7627 15.3004 14.0163 14.0516C14.7381 13.3353 15.2829 12.4605 15.6073 11.4968C15.6448 11.3827 15.7052 11.2774 15.7849 11.1874C15.8645 11.0975 15.9616 11.0247 16.0703 10.9736C16.1791 10.9225 16.2971 10.8942 16.4171 10.8903Z"
                                            fill="#89B1FF"
                                        />
                                    </svg>
                                </div>
                            )}
                        </div>
                    )
                )}
            </div>
            {open && sponsor && (
                <Modal
                    classModal="profile-modal"
                    closeBtn={() => {
                        setOpen(false);
                    }}>
                    <ShortProfile
                        {...sponsor}
                        view={true}
                    />
                </Modal>
            )}
        </>
    );
};

const Profile: FC = () => {
    const [addRef, setAddRef] = useState(false);
    const [selectRef, setSelectRef] = useState<Account_Info | null>();

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const accountClient = new AccountClient(transport);

    useEffect(() => {
        if (!addRef) setSelectRef(null);
    }, [addRef]);

    function saveRef() {
        if (!selectRef?.account?.id) return;

        accountClient
            .setReferral(
                { uniqueField: { accountId: selectRef?.account?.id, oneofKind: 'accountId' } },
                { meta: { authorization: getToken() } }
            )
            .then(({ status, response }) => {
                if (status.code === 'OK') {
                    setAddRef(false);
                    message.success('Спонсор добавлен');
                    dispatch(resetUser({ info: response }));
                }
            })
            .catch((error) => {
                if (isRpcError(error)) {
                    switch (error.message) {
                        case 'REFERRAL_UNKNOWN':
                            message.error('Не известный спонсор');
                            break;
                        case 'REFERRAL_WRONG_LINK':
                            message.error('Не верная ссылка');
                            break;
                        case 'REFERRAL_BUSY':
                            message.error('Спонсор занят');
                            break;
                        case 'REFERRAL_EXISTS':
                            message.error('У вас уже есть спонсор');

                            setAddRef(false);
                            break;
                        default:
                            break;
                    }
                }
            });
    }

    return (
        <>
            <div className="profile">
                <Title text={t('profile.setting_title')} />
                <AboutUser />
                <div className="line"></div>
                <Title text={t('profile.ref_title')} />
                <Partner setAddRef={setAddRef} />
                <div className="line"></div>
                <TwoFACHeck />
                <div className="line"></div>
                <Web3 />
            </div>
            {addRef && (
                <IosModal
                    cancelBtnTitle={selectRef ? t('modals.ios.header.btns.back') : t('modals.ios.header.btns.cancel')}
                    aproveBtnTitle={selectRef ? t('modals.ios.header.btns.confirm') : ''}
                    title={t('modals.ios.header.titles.referral')}
                    aprove={() => saveRef()}
                    cancel={() => setAddRef(false)}>
                    <>
                        {selectRef ? (
                            <ShortProfile
                                {...selectRef}
                                dont={true}
                            />
                        ) : (
                            <Search
                                placeholder={t('placeholders.login_referral')}
                                setSelect={setSelectRef}
                            />
                        )}
                    </>
                </IosModal>
            )}
        </>
    );
};

export default Profile;
